module.exports = __webpack_public_path__ + "static/media/eventsThumb2.05b858a3.jpg";